import React, { useState } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import Connect from './pages/Connect';
import CameraStream from './pages/CameraStream';
import Login from './pages/Login';
import Monitoring from './pages/Monitoring';
import Reporting from './pages/Reporting';
import Manage from './pages/Manage';
import { clearAuthSession, getStoredAuthClaims, getStoredAuthToken, isAdminUser, parseJwt, storeAuthSession } from './utils/auth';
import './App.css';

function ProtectedRoute({ isAuthenticated, children }) {
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

function AdminRoute({ isAdmin, children }) {
  if (!isAdmin) {
    return <Navigate to="/connect" replace />;
  }

  return children;
}

function App() {
  const [authToken, setAuthToken] = useState(() => getStoredAuthToken());
  const [authClaims, setAuthClaims] = useState(() => getStoredAuthClaims() || (authToken ? parseJwt(authToken) : null));
  const isAuthenticated = Boolean(authToken);
  const isAdmin = isAdminUser(authClaims);
  const routerBasename = process.env.PUBLIC_URL || '/';

  const handleLogin = (token) => {
    const claims = storeAuthSession(token);
    setAuthToken(token);
    setAuthClaims(claims);
  };

  const handleLogout = () => {
    clearAuthSession();
    setAuthToken(null);
    setAuthClaims(null);
  };

  return (
    <Router basename={routerBasename}>
      <div className="app-container">
        <Navigation isAuthenticated={isAuthenticated} isAdmin={isAdmin} onLogout={handleLogout} />
        <main>
          <Routes>
            <Route path="/" element={<Connect />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/connect/stream" element={<CameraStream />} />
            <Route
              path="/login"
              element={<Login isAuthenticated={isAuthenticated} onLogin={handleLogin} />}
            />
            <Route
              path="/monitoring"
              element={(
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Monitoring />
                </ProtectedRoute>
              )}
            />
            <Route
              path="/manage"
              element={(
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <AdminRoute isAdmin={isAdmin}>
                    <Manage />
                  </AdminRoute>
                </ProtectedRoute>
              )}
            />
            <Route
              path="/reporting"
              element={(
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <Reporting />
                </ProtectedRoute>
              )}
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
